<div class="container">
  <md-card class="card">
    <md-card class="card">
      <md-card-title>
        <div class="title"><md-icon>supervised_user_circle</md-icon>Users</div>
        <md-form-field>
          <input
            name="search"
            mdInput
            placeholder="Filter By Login / Name / Profile"
            class="md2-input"
            [(ngModel)]="userSearch"
          />
        </md-form-field>
        <button
          md-mini-fab
          color="primary"
          (click)="addUser()"
          *ngIf="editMode"
          mdTooltip="Add a user"
        >
          <md-icon class="md-24" aria-label="Add a user">person_add</md-icon>
        </button>
      </md-card-title>
      <md-card-content>
        <app-spinner *ngIf="!users"></app-spinner>
        <table
          [md2Data]="
            users
              | searchByTerm
                : userSearch
                : ['login', 'firstName', 'lastName', 'profiles.value']
          "
          #md2Users="md2DataTable"
          [rowsPerPage]="10"
        >
          <thead>
            <tr>
              <th style="width: 20%" md2SortBy="login">Login</th>
              <th style="width: 30%" md2SortBy="fullName">Name</th>
              <th style="width: 30%">Profiles</th>
              <th style="width: 5%">Specific</th>
              <th style="width: 15%">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of md2Users.data" class="row">
              <td>{{ user.login }}</td>
              <td>{{ user.fullName }}</td>
              <td class="center">
                <md-chip-list>
                  <md-chip
                    *ngFor="let profile of user.profiles"
                    color="accent"
                    selected="true"
                    >{{ profile.value }}
                  </md-chip>
                </md-chip-list>
              </td>
              <td class="center">
                <md-icon
                  *ngIf="user.specificRights"
                  color="primary"
                  mdTooltip="This user has specific rights"
                >
                  check_circle</md-icon
                >
              </td>
              <td class="center" *ngIf="editMode">
                <md-icon
                  *ngIf="user.isLocked"
                  (click)="unlockUser(user)"
                  class="cursor-pointer"
                  color="primary"
                  mdTooltip="Unlock"
                  >lock</md-icon
                >
                <md-icon
                  (click)="editUser(user)"
                  class="cursor-pointer"
                  color="primary"
                  mdTooltip="Edit"
                  >edit</md-icon
                >
                <md-icon
                  (click)="deleteUser(user)"
                  class="cursor-pointer"
                  color="warn"
                  mdTooltip="Delete"
                  >delete
                </md-icon>
              </td>
              <td class="center" *ngIf="!editMode">
                <md-icon
                  (click)="editUser(user)"
                  class="cursor-pointer"
                  color="primary"
                  mdTooltip="View"
                  >assignment
                </md-icon>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="4">
                <md2-pagination
                  [rowsPerPageSet]="[5, 10, 15]"
                  paginationLabel="Rows per page"
                ></md2-pagination>
              </td>
            </tr>
          </tfoot>
        </table>
      </md-card-content>
    </md-card>
    <md-card class="card">
      <md-card-title>
        <div class="title"><md-icon>map</md-icon>Feature per Language</div>
        <button
          color="primary"
          md-mini-fab
          (click)="editFeatures()"
          *ngIf="editMode && !featureEditionMode"
          mdTooltip="Enable a feature for a language"
        >
          <md-icon class="md-24" aria-label="Add a profile">edit</md-icon>
        </button>
      </md-card-title>
      <md-card-content class="center">
        <app-spinner *ngIf="!features"></app-spinner>
        <table [md2Data]="features" #md2Features="md2DataTable">
          <thead>
            <tr>
              <th style="width: 50%" md2SortBy="value">Action</th>
              <th style="width: 50%">Languages</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let feature of md2Features.data" class="row">
              <td>{{ feature.name }}</td>
              <td *ngIf="!featureEditionMode">{{ feature.languagesString }}</td>
              <td *ngIf="featureEditionMode">
                <md2-select
                  placeholder="Languages available"
                  name="languages"
                  [(ngModel)]="feature.languages"
                  [multiple]="true"
                  (change)="changeFeatureLanguages(feature.code)"
                >
                  <md2-option [value]="allLanguage">SELECT ALL</md2-option>
                  <md2-option
                    *ngFor="
                      let language of languages | orderBy : 'value' : 'asc'
                    "
                    [value]="language"
                  >
                    {{ language.value }}</md2-option
                  >
                </md2-select>
              </td>
            </tr>
          </tbody>
        </table>
        <button
          class="button-save-feature"
          *ngIf="featureEditionMode"
          type="button"
          md-raised-button
          color="accent"
          (click)="saveFeatures()"
        >
          <md-icon>save</md-icon>
          Save
        </button>
      </md-card-content>
    </md-card>
  </md-card>
  <md-card class="card">
    <md-card class="card">
      <md-card-title>
        <div class="title"><md-icon>style</md-icon>Profiles</div>
        <md-form-field>
          <input
            name="search"
            mdInput
            placeholder="Filter By Name"
            class="md2-input"
            [(ngModel)]="profileSearch"
          />
        </md-form-field>
        <button
          color="primary"
          md-mini-fab
          (click)="addProfile()"
          *ngIf="editMode"
          mdTooltip="Add a profile"
        >
          <md-icon class="md-24" aria-label="Add a profile">add</md-icon>
        </button>
      </md-card-title>
      <md-card-content>
        <app-spinner *ngIf="!profiles"></app-spinner>
        <table
          [md2Data]="profiles | searchByTerm : profileSearch : ['value']"
          #md2Profiles="md2DataTable"
          [rowsPerPage]="10"
        >
          <thead>
            <tr>
              <th style="width: 80%" md2SortBy="value">Name</th>
              <th style="width: 20%">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let profile of md2Profiles.data" class="row">
              <td>{{ profile.value }}</td>
              <td class="center" *ngIf="editMode">
                <md-icon
                  class="cursor-pointer"
                  (click)="editProfile(profile)"
                  color="primary"
                  mdTooltip="Edit"
                  >edit
                </md-icon>
                <md-icon
                  class="cursor-pointer"
                  (click)="deleteProfile(profile)"
                  color="warn"
                  mdTooltip="Delete"
                  >delete
                </md-icon>
              </td>
              <td class="center" *ngIf="!editMode">
                <md-icon
                  class="cursor-pointer"
                  (click)="editProfile(profile)"
                  color="primary"
                  mdTooltip="View"
                >
                  assignment
                </md-icon>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="4">
                <md2-pagination
                  [rowsPerPageSet]="[5, 10, 15]"
                  paginationLabel="Rows per page"
                ></md2-pagination>
              </td>
            </tr>
          </tfoot>
        </table>
      </md-card-content>
    </md-card>

    <!-- <md-card class="card">
      <md-card-title>
        <div class="title"><md-icon>map</md-icon>Duplicate per Language</div>
        <button
          color="primary"
          md-mini-fab
          (click)="editDataDuplicateLanguage()"
          *ngIf="editMode && !dataDuplicateLanguageEditionMode"
          mdTooltip="Enable a data duplicate for a language"
        >
          <md-icon class="md-24" aria-label="Add a profile">edit</md-icon>
        </button>
      </md-card-title>
      <md-card-content class="center">
        <app-spinner *ngIf="!dataDuplicateLanguage"></app-spinner>
        <table>
          <thead>
            <tr>
              <th style="width: 50%">Language to duplicate</th>
              <th style="width: 50%">Languages</th>
            </tr>
          </thead>
          <tbody>
            <tr class="row">
              <td
                *ngIf="
                  !dataDuplicateLanguageEditionMode &&
                  dataDuplicateLanguage.languageToDuplicate != null
                "
              >
                {{ dataDuplicateLanguage.languageToDuplicate.value }}
              </td>
              <td *ngIf="dataDuplicateLanguageEditionMode">
                <md2-select
                  placeholder="Languages to duplicate available"
                  name="languageToDuplicate"
                  [(ngModel)]="dataDuplicateLanguage.languageToDuplicate"
                  [multiple]="false"
                >
                  <md-option value=""></md-option>
                  <md2-option
                    *ngFor="
                      let language of languages | orderBy : 'value' : 'asc'
                    "
                    [value]="language"
                  >
                    {{ language.value }}</md2-option
                  >
                </md2-select>
              </td>
              <td *ngIf="!dataDuplicateLanguageEditionMode">
                {{ dataDuplicateLanguage.languagesString }}
              </td>
              <td *ngIf="dataDuplicateLanguageEditionMode">
                <md2-select
                  placeholder="Languages available"
                  name="languages"
                  [(ngModel)]="dataDuplicateLanguage.languages"
                  [multiple]="true"
                >
                  <md2-option
                    (click)="clickOnSelectAllDuplicateLanguage()"
                    [value]="allLanguage"
                    >SELECT ALL</md2-option
                  >
                  <md2-option
                    *ngFor="
                      let language of languages | orderBy : 'value' : 'asc'
                    "
                    [value]="language"
                  >
                    {{ language.value }}</md2-option
                  >
                </md2-select>
              </td>
            </tr>
          </tbody>
        </table>
        <button
          class="button-save-feature"
          *ngIf="dataDuplicateLanguageEditionMode"
          type="button"
          md-raised-button
          color="accent"
          (click)="saveDataDuplicateLanguage()"
        >
          <md-icon>save</md-icon>
          Save
        </button>
      </md-card-content> 
    </md-card>-->
  </md-card>
</div>



// WEBPACK FOOTER //
// ./src/app/pages/admin/admin.component.html